import React, { useEffect, useState } from "react";
import { Building2, Plus, X, Pencil, Trash2 } from "lucide-react";
import {
  createBranch,
  getBranches,
  //   deleteBranch,
} from "../services/branchService";
import { toast } from "react-toastify";
import SectionHeader from "../components/SectionHeader";

const CreateBranch = () => {
  const [formData, setFormData] = useState({
    branchName: "",
    branchCode: "",
  });

  const [branches, setBranches] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editingBranch, setEditingBranch] = useState(null);
  // 📦 Fetch branches
  const fetchBranches = async () => {
    try {
      const res = await getBranches();
      if (res?.data && Array.isArray(res?.data)) {
        setBranches(res.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ➕ Create
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!formData.branchName || !formData.branchCode) {
      toast.error("Please fill in all fields");
      setLoading(false);
      return;
    }

    try {
      const res = await createBranch(formData);
      console.log("res", res);
      toast.success(res?.data?.message);
      setFormData({ branchName: "", branchCode: "" });
      setOpen(false);
      fetchBranches();
    } catch (err) {
      toast.error(err.response?.data?.error || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // 🗑 Delete
  //   const handleDelete = async (id) => {
  //     if (!window.confirm("Delete this branch?")) return;
  //     try {
  //       //   await deleteBranch(id);
  //       fetchBranches();
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   };

  return (
    <div className="p-4 relative">
      {/* 🔹 Header */}
      <SectionHeader
        title="Branches"
        subTitle="Manage your company's branches. Create new ones or edit existing ones."
      />

      {/* 🔹 Table */}
      <div className="bg-white rounded-xl shadow border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-100 text-gray-600">
            <tr>
              <th className="p-3 text-left">Branch Name</th>
              <th className="p-3 text-left">Branch Code</th>
              <th className="p-3 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {branches?.map((b) => (
              <tr key={b._id} className="border-t hover:bg-gray-50">
                <td className="p-3">{b.branchName}</td>
                <td className="p-3">{b.branchCode}</td>

                <td className="p-3 flex justify-center gap-2">
                  <button
                    className="p-2 bg-blue-100 text-blue-600 rounded-lg"
                    onClick={() => {
                      setEditingBranch(b);
                      setFormData({
                        branchName: b.branchName,
                        branchCode: b.branchCode,
                      });
                      setOpen(true);
                    }}
                  >
                    <Pencil size={16} />
                  </button>

                  {/* <button
                    onClick={() => handleDelete(b._id)}
                    className="p-2 bg-red-100 text-red-600 rounded-lg"
                  >
                    <Trash2 size={16} />
                  </button> */}
                </td>
              </tr>
            ))}

            {branches?.length === 0 && (
              <tr>
                <td colSpan="3" className="text-center p-6 text-gray-400">
                  No branches found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ➕ Floating Button */}
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:scale-105 transition"
      >
        <Plus />
      </button>

      {/* 🪟 Modal */}
      {open && (
        <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
          <div className="w-full max-w-lg bg-white rounded-2xl p-8 shadow-xl relative">
            {/* Close */}
            <button
              onClick={() => {
                setOpen(false);
                setEditingBranch(null);
                setFormData({ branchName: "", branchCode: "" });
              }}
              className="absolute top-4 right-4 text-gray-500"
            >
              <X />
            </button>

            {/* Header */}
            <div className="flex items-center gap-3 mb-6">
              <div className="p-3 bg-blue-100 text-blue-600 rounded-xl">
                <Building2 size={22} />
              </div>
              <h2 className="text-xl font-semibold">Create Branch</h2>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm mb-2 font-medium text-gray-700">
                  Branch Name
                </label>

                <input
                  type="text"
                  name="branchName"
                  value={formData.branchName}
                  onChange={handleChange}
                  placeholder="Branch Name"
                  className="w-full px-4 py-2.5 border rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm mb-2 font-medium text-gray-700">
                  Branch Code
                </label>

                <input
                  type="text"
                  name="branchCode"
                  value={formData.branchCode}
                  onChange={handleChange}
                  placeholder="Branch Code"
                  className="w-full px-4 py-2.5 border rounded-lg"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 bg-blue-600 text-white rounded-lg"
              >
                {loading ? "Creating..." : "Create Branch"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateBranch;
